<div class="p-15px d-flex justify-content-center align-items-center br-3px">
  <img [src]="imageURL" style="max-height: 100%; max-width: 100%" />
</div>
